// Яндекс.Метрика, поведенческие факторы для ранжирования в Яндексе и
// связка с Вебмастером. Выключена, пока не задан VITE_YM_COUNTER_ID.
// Скрипт грузится только после согласия на аналитику (cookie-баннер) и
// не ставит cookies до него. Перед включением обнови /legal/cookies
// (п. 2.2 сейчас говорит «аналитические сервисы не подключены») и подними
// CONSENT_VERSION в lib/cookies.ts, чтобы баннер спросил заново.

import { getConsent, onConsentChange } from './cookies';

declare global {
  interface Window {
    ym?: ((...args: unknown[]) => void) & { a?: unknown[]; l?: number };
  }
}

const COUNTER_ID = Number(import.meta.env.VITE_YM_COUNTER_ID?.trim() || 0) || 0;
const TAG_SRC = 'https://mc.yandex.ru/metrika/tag.js';

let loaded = false;
let allowed = false;

export function isMetrikaEnabled(): boolean {
  return COUNTER_ID > 0;
}

export function setupMetrika(): void {
  if (!isMetrikaEnabled() || typeof window === 'undefined') return;
  sync(!!getConsent()?.analytics);
  onConsentChange((state) => sync(!!state?.analytics));
}

function sync(consented: boolean) {
  allowed = consented;
  if (consented) load();
}

function load() {
  if (loaded) return;
  loaded = true;

  const w = window;
  if (!w.ym) {
    const ym = function (...args: unknown[]) {
      (ym.a = ym.a || []).push(args);
    } as NonNullable<Window['ym']>;
    ym.l = Date.now();
    w.ym = ym;
  }
  const script = document.createElement('script');
  script.async = true;
  script.src = TAG_SRC;
  document.head.appendChild(script);

  // defer: первый просмотр отправляем сами, так же, как и все SPA-переходы.
  w.ym(COUNTER_ID, 'init', {
    defer: true,
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: false,
  });
  hit(window.location.pathname + window.location.search, document.title);
}

function hit(url: string, title: string) {
  window.ym?.(COUNTER_ID, 'hit', url, { title, referer: document.referrer || undefined });
}

/** Вызывается RouteSeo на каждом маршруте. До согласия/загрузки, no-op. */
export function trackPageView(pathname: string, title: string): void {
  if (!loaded || !allowed) return;
  hit(pathname + window.location.search, title);
}
